import { schema } from 'normalizr';


export const labelSymbolCorrectiveActionSchema = new schema.Entity(
  'labelSymbolCorrectiveActions',
  {},
  { idAttribute: 'Code' },
);
export const labelSymbolCorrectiveActionListSchema = [labelSymbolCorrectiveActionSchema];
